/**
 * PostHog for the Parée Care Shopify storefront (same project as paree.care).
 *
 * `__POSTHOG_*__` placeholders are replaced by theme/apply-brand.mjs from
 * POSTHOG_PROJECT_TOKEN / POSTHOG_HOST / POSTHOG_UI_HOST at brand-apply time.
 * The committed file never holds a real token.
 *
 * Loads synchronously (no defer) so the first pageview lands with person
 * profiles + session recording already on. Ignores cookie-banner consent —
 * every session is recorded.
 *
 * Injected into layout/theme.liquid by theme/apply-brand.mjs.
 */
;(function () {
  var TOKEN = 'phc_pmiC8CJdjP3ta5ZTiaKUavmvW8DX7aUmgtJw7qn9xnZX'
  var API_HOST = 'https://us.i.posthog.com'
  var UI_HOST = 'https://us.posthog.com'

  if (!TOKEN || TOKEN.indexOf('__POSTHOG_') === 0) {
    console.warn(
      '[paree-posthog] token missing — set POSTHOG_PROJECT_TOKEN and re-run pnpm theme:brand -- --write',
    )
    return
  }

  if (API_HOST.indexOf('__POSTHOG_') === 0) API_HOST = 'https://us.i.posthog.com'
  if (UI_HOST.indexOf('__POSTHOG_') === 0) UI_HOST = 'https://us.posthog.com'

  // Official loader — sync, so init runs before deferred brand scripts and first paint interactions.
  !(function (t, e) {
    var o, n, p, r
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split('.')
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
            })
        }
        ;((p = t.createElement('script')).type = 'text/javascript'),
          (p.crossOrigin = 'anonymous'),
          (p.async = true),
          (p.src =
            s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') +
            '/static/array.js'),
          (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r)
        var u = e
        for (
          void 0 !== a ? (u = e[a] = []) : (a = 'posthog'),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = 'posthog'
              return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e
            },
            u.people.toString = function () {
              return u.toString(1) + '.people (stub)'
            },
            o =
              'init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug'.split(
                ' ',
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n])
        e._i.push([i, s, a])
      }),
      (e.__SV = 1))
  })(document, window.posthog || [])

  var onPareeCare =
    typeof location !== 'undefined' && /\.paree\.care$/i.test(location.hostname)

  var bootstrap
  var customer = window.__PARE_CUSTOMER__
  if (customer && customer.email) {
    var email = String(customer.email).trim().toLowerCase()
    if (email) {
      var personProperties = { email: email, site: 'shop' }
      if (customer.id != null) personProperties.shopify_customer_id = String(customer.id)
      if (customer.first_name) personProperties.first_name = customer.first_name
      if (customer.last_name) personProperties.last_name = customer.last_name
      bootstrap = {
        distinctID: email,
        isIdentifiedID: true,
        personProperties: personProperties,
      }
    }
  }

  posthog.init(TOKEN, {
    api_host: API_HOST,
    ui_host: UI_HOST,
    defaults: '2026-05-30',
    persistence: 'localStorage+cookie',
    person_profiles: 'always',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    disable_session_recording: false,
    opt_out_capturing_by_default: false,
    // shop.paree.care ↔ paree.care share the parent cookie when both use this.
    cross_subdomain_cookie: onPareeCare,
    bootstrap: bootstrap,
    session_recording: {
      maskAllInputs: true,
      recordCrossOriginIframes: false,
    },
    loaded: function (ph) {
      // Force recording even if project ingest controls would skip it.
      // By default startSessionRecording() still obeys URL/event triggers and
      // sampling — this project had a trigger group that only started on
      // pathname icontains `/intake` (the telehealth funnel), so shop traffic
      // produced pageviews and zero replays. `true` ignores those controls.
      try {
        ph.opt_in_capturing()
      } catch (e) {
        /* stub */
      }
      try {
        ph.startSessionRecording(true)
      } catch (e) {
        try {
          ph.startSessionRecording()
        } catch (e2) {
          /* stub */
        }
      }

      ph.register({
        site: 'shop',
        property: 'shopify',
        shop_host: location.hostname,
      })

      // Re-identify in case bootstrap was absent (anonymous → later login).
      identifyFromBootstrap(ph)
      wireErrors(ph)
      wireStorefrontActions(ph)
    },
  })

  /**
   * Safe capture helper for inline section scripts (set buy, plan start).
   * Always tags site=shop; $host is also set by the SDK automatically.
   */
  window.pareeCapture = function (event, props) {
    try {
      if (!window.posthog || typeof posthog.capture !== 'function') return
      var payload = Object.assign({ site: 'shop' }, props || {})
      posthog.capture(event, payload)
    } catch (e) {
      /* never break checkout flows for analytics */
    }
  }

  window.pareeIdentify = function (email, props) {
    try {
      if (!email || !window.posthog || typeof posthog.identify !== 'function') return
      var id = String(email).trim().toLowerCase()
      if (!id) return
      posthog.identify(id, Object.assign({ email: id, site: 'shop' }, props || {}))
    } catch (e) {
      /* ignore */
    }
  }

  function identifyFromBootstrap(ph) {
    var customer = window.__PARE_CUSTOMER__
    if (!customer || !customer.email) return
    var email = String(customer.email).trim().toLowerCase()
    if (!email) return
    var traits = { email: email, site: 'shop' }
    if (customer.id != null) traits.shopify_customer_id = String(customer.id)
    if (customer.first_name) traits.first_name = customer.first_name
    if (customer.last_name) traits.last_name = customer.last_name
    ph.identify(email, traits)
  }

  function wireErrors(ph) {
    window.addEventListener('error', function (event) {
      try {
        ph.captureException(event.error || new Error(event.message || 'window_error'), {
          site: 'shop',
          source: event.filename,
          line: event.lineno,
          col: event.colno,
        })
      } catch (e) {
        ph.capture('js_error', {
          site: 'shop',
          message: String(event.message || ''),
          source: event.filename,
          line: event.lineno,
        })
      }
    })

    window.addEventListener('unhandledrejection', function (event) {
      var reason = event.reason
      try {
        ph.captureException(reason instanceof Error ? reason : new Error(String(reason)), {
          site: 'shop',
          kind: 'unhandledrejection',
        })
      } catch (e) {
        ph.capture('js_unhandledrejection', {
          site: 'shop',
          message: String(reason && reason.message ? reason.message : reason),
        })
      }
    })

    if (typeof console !== 'undefined' && console.warn) {
      var origWarn = console.warn.bind(console)
      console.warn = function () {
        try {
          var message = Array.prototype.slice.call(arguments).map(String).join(' ')
          if (message && message.indexOf('[paree-posthog]') === -1) {
            ph.capture('console_warning', {
              site: 'shop',
              message: message.slice(0, 500),
            })
          }
        } catch (e) {
          /* ignore */
        }
        return origWarn.apply(console, arguments)
      }
    }
  }

  function wireStorefrontActions(ph) {
    // Contact form: identify on submit (email available before Shopify navigates).
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target
        if (!form || form.tagName !== 'FORM') return

        var emailInput =
          form.querySelector('[name="contact[email]"]') ||
          form.querySelector('input[type="email"]')
        if (form.querySelector('[name="contact[email]"]') || form.classList.contains('contact-form')) {
          var email = emailInput && emailInput.value ? String(emailInput.value).trim() : ''
          if (email) {
            window.pareeIdentify(email, { source: 'contact_form' })
            ph.capture('contact_submitted', { site: 'shop' })
          }
          return
        }

        // Native product add-to-cart (theme product form).
        var action = (form.getAttribute('action') || '').toLowerCase()
        if (action.indexOf('/cart/add') !== -1) {
          var idInput = form.querySelector('[name="id"]')
          var handleEl = document.querySelector('[data-product-handle], meta[property="og:url"]')
          var handle = ''
          if (handleEl && handleEl.getAttribute) {
            handle =
              handleEl.getAttribute('data-product-handle') ||
              ''
          }
          ph.capture('product_added_to_cart', {
            site: 'shop',
            variant_id: idInput && idInput.value ? String(idInput.value) : undefined,
            product_handle: handle || undefined,
          })
        }
      },
      true,
    )

    // Contact success page (Shopify reloads with .form-status).
    function noteContactSuccess() {
      if (!document.querySelector('.contact .form-status')) return
      ph.capture('contact_success_viewed', { site: 'shop' })
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', noteContactSuccess)
    } else {
      noteContactSuccess()
    }

    // Search submit.
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target
        if (!form || form.tagName !== 'FORM') return
        var q =
          form.querySelector('[name="q"]') ||
          form.querySelector('input[type="search"]')
        if (!q) return
        var action = (form.getAttribute('action') || '').toLowerCase()
        if (action.indexOf('search') === -1 && !form.querySelector('[name="q"]')) return
        var query = String(q.value || '').trim()
        if (!query) return
        ph.capture('search_submitted', { site: 'shop', query: query.slice(0, 200) })
      },
      true,
    )
  }
})()
